<template>
    <div class="container" style="margin:2% auto">
        <div class="columns">
            <div class="column is-12">
                <h1 class="title">All Users ({{meta.total}})</h1>

                <!-- <b-select v-model="perPage" :disabled="!isPaginated">
                  <option value="50">50 per page</option>
                  <option value="100">100 per page</option>
                  <option value="150">150 per page</option>
                  <option value="1000">1000 per page</option>
                </b-select> -->
                <div class="column" v-if="selectedUsers.length!=0">
        <button class="button is-secondary download_button" @click="downloadCSV">Download CSV</button>
      </div>

                <b-table
                    :data="isEmpty ? [] : Users"
                    :paginated="isPaginated"
                    :per-page="perPage"
                    :current-page.sync="currentPage"
                    :pagination-simple="isPaginationSimple"
                    :pagination-position="paginationPosition"
                    :default-sort-direction="defaultSortDirection"
                    :sort-icon="sortIcon"
                    :sort-icon-size="sortIconSize"
                    :bordered="true"
                    :striped="true"
                    :narrowed="true"
                    :hoverable="true"
                    :loading="isLoading"
                    :focusable="true"
                    :selected-sync="selected"
                    :mobile-cards="true"
                    checkable
                    :checked-rows.sync="selectedUsers"
                    >

                    <template slot-scope="props">

                        <b-table-column field="name" label="Name">
                          {{ props.row.name }}
                        </b-table-column>
                                     <b-table-column field="email" label="Email"> {{ props.row.email ? `${props.row.email}` : ''}}
                        </b-table-column>

                        <b-table-column field="amount" label="Mobile Number">
                          {{ props.row.mobileNumber }}
                        </b-table-column>

                        <b-table-column field="type" label="User Type">
                          {{ props.row.type }}
                        </b-table-column>

                                  <b-table-column field="reset" label="Reset Code">
                          {{ props.row.code }}
                        </b-table-column>

                        <b-table-column label="Actions">
                          <button class="button is-secondary is-outlined" @click="openEditUserModal(props.row)">Edit</button>
                             <!-- <button class="button is-secondary is-outlined" @click="openDriverOrdersModal(props.row)">View Orders</button> -->
                          <button class="button is-danger is-outlined" @click="openDeleteUserModal(props.row)">Delete</button>
                        </b-table-column>
                    </template>

                    <template slot="empty" v-if="!isLoading && Users.length == 0">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                  <b-icon
                                    icon="emoticon-sad"
                                    size="is-large">
                                  </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>
                </b-table>

            </div>
        </div>
    </div>
</template>

<script>

import { exportCSVFile, days, months, cleanStr, getSuburb } from "@/helpers";
const EditModal = () => import('@/components/Users/EditUserModal');
const DeleteModal = () => import('@/components/Users/DeleteUserModal');
export default {
    name: "Users",
    data() {
        return {
            isLoading: false,
            selected: [],
            Users: [],
            isPaginated: true,
            isPaginationSimple: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 20,
            selectedUsers: [],
            meta: {
              total: 0
            }
        }
    },
    computed: {
      isEmpty() {
        return this.loading == true && this.Users.length == 0;
      },
      currentShowing() {
        return (this.Users.length) - ((this.currentPage > 0 ? 1 : this.currentPage-1) * this.perPage)
      }
    },
    created() {
      this.getUsers()
    },
    methods: {
        getUsers() {
          this.isLoading = true;
          this.$store.dispatch('getUsers').then(({users, meta }) => {

            this.isLoading = false;
            if(users && users.length > 0) {
                this.Users = users;
                this.meta = meta;
            } else {
                this.Users = [];
                
                this.$toasted.global.error('Users not found.');
            }
          }).catch(e=> {
            this.isLoading = false;
            console.log('Exception when getting Users.',e);
            this.$toasted.global.error('Failed to get Users.');
            this.Users = [];
          })
        },
        goToBox() {
          this.$store.commit('selectedBox', this.selected[0]);
        },
        openEditUserModal(user) {
          this.$modal.open({
            component: EditModal,
            parent: this,
            props: {
               user
            },
            events: {
              reload: ()=> {
                this.getUsers();
              }
            }
          })
        },
        openDeleteUserModal(user) {
          this.$modal.open({
            component: DeleteModal,
            parent: this,
            props: {
              user
            },
            events: {
              reload: ()=> {
                this.getUsers();
              }
            }
          })
        },
        downloadCSV() {
        if (this.selectedUsers.length == 0)
          return this.$toasted.global.error("Atleast select something.");

          const users = [];

          this.selectedUsers.forEach(user => {

            const tmp = {
              custome_name: cleanStr(user.name),
              mobile_number: cleanStr(user.mobileNumber),
              email:cleanStr(user.email)

            };

            users.push(tmp);

            // if (order.products.length > 1) {

            //   for (let i = 1; i < order.products.length; i++) {
            //     const product = order.products[i];
            //     orders.push({
            //       customer_name: "",
            //       mobile_number: "",
            //       email:""

            //     });
            //   }
            // }
          });
          const date = new Date();
          const month = months[date.getMonth()];
          const day = days[date.getDay()];
          const filename = `${day},${date.getDate()} ${month} ${date.getFullYear()} ${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}-Users`;

          exportCSVFile(
            {
              customer_name: "Customer Name",
              mobile_number: "Mobile Number",
              email:"Email"


            },
            users,
            filename
          );
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/AllUsers.vue